import { useState, useEffect, useCallback } from 'react';
import adminApi from '../services/adminApi';
import api from '../services/api';

export const useClients = (isAdmin = false) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchClients = useCallback(async () => {
    try {
      setLoading(true);
      const data = isAdmin 
        ? await adminApi.getClients()
        : await api.getWithoutClientId('/clients');
      setClients(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      setClients([]);
    } finally {
      setLoading(false);
    }
  }, [isAdmin]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  const deleteClient = async (clientId) => {
    try {
      await adminApi.deleteClient(clientId);
      await fetchClients();
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    }
  };

  const activateClient = async (clientId) => {
    try {
      await adminApi.activateClient(clientId);
      await fetchClients();
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    }
  };

  return {
    clients,
    loading,
    error,
    fetchClients,
    deleteClient,
    activateClient
  };
}; 